// removed by extract-text-webpack-plugin
module.exports = {"msgContainer":"rvSXXb4mktO99FEjX20fY","msg":"_2l_ksGIcm4XWysh1GTsAxa","imageContainer":"_3atV43t7EcKKEuLJOI09fC","textContainer":"ZvUIcfSGS0tMJhQS-eDpV"};


//////////////////
// WEBPACK FOOTER
// ./components/tooManyResults.scss
// module id = 1628
// module chunks = 0